import type { Middleware } from "openapi-fetch";
import { acquireMsalManagementToken, initializeMsal, msalManagementInstance } from "../auth/msalManagement.ts";

interface MsalMiddlewareOptions {
    headerName: string;
}

export function setMsalManagementTokenMiddleware({ headerName }: MsalMiddlewareOptions): Middleware {
    return {
        async onRequest({ request }) {
            await initializeMsal();

            // Only set the jwt token if the user is logged in
            if (!msalManagementInstance.getActiveAccount()) {
                return request;
            }

            try {
                const authResult = await acquireMsalManagementToken();
                request.headers.set(headerName, authResult.idToken);
            } catch (error) {
                console.error("Failed to set msal token in request", error);
            }

            return request;
        }
    };
}
